import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const PROJECT_TYPES = [["all", "All types"], ["standard", "Standard"], ["internal", "Internal"], ["cmoaas", "CMOaaS"]];

export function TypeFilter({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-0.5 rounded-full border border-[#EEEFEF] bg-white p-0.5" data-testid="projects-filter-type">
      {PROJECT_TYPES.map(([k, label]) => (
        <button key={k} data-testid={`projects-type-${k}`} onClick={() => onChange(k)}
          className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${value === k ? "bg-[#06060C] text-white" : "text-[#595D62] hover:bg-[#F6F6FD]"}`}>{label}</button>
      ))}
    </div>
  );
}

export function NewInternalProjectDialog({ clients, onClose, onCreated }) {
  const agency = clients.find((c) => c.is_agency);
  const [wid, setWid] = useState(agency?.id || clients[0]?.id || "");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const create = async () => {
    setBusy(true);
    try { await api.post("/console/internal", { workspace_id: wid, name }); toast.success("Internal project created"); onCreated(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent onEscapeKeyDown={onClose} className="bg-white border-[#EEEFEF] max-w-md" data-testid="new-internal-project-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">New internal project</DialogTitle>
          <DialogDescription>Only your agency team sees internal projects. Clients never do.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><label className="text-xs text-[#9FA1A4] mb-1 block">Workspace</label>
            <select data-testid="new-internal-workspace" value={wid} onChange={(e) => setWid(e.target.value)} className="h-9 w-full rounded-md bg-[#F6F6FD] border border-[#EEEFEF] px-2 text-sm">
              {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select></div>
          <div><label className="text-xs text-[#9FA1A4] mb-1 block">Project name</label>
            <Input autoFocus data-testid="new-internal-name" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && name.trim() && wid && create()} placeholder="e.g. Website refresh" className="bg-[#F6F6FD] border-[#EEEFEF]" /></div>
        </div>
        <DialogFooter>
          <Button data-testid="new-internal-create" disabled={busy || !name.trim() || !wid} onClick={create} className="rounded-full bg-[#06060C] text-white hover:bg-[#1c1c24]">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create project"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
